import {
  insertSupplier,
  editSupplier,
  getAllSuppliers,
  getSupplierById,
  deleteSupplier,
} from "../../../api/divvy-manageSuppliers";

const manageSuppliers = {
  namespaced: true,
  state: () => ({
    suppliersResults: [],
    suppliers: [],
    supplier: {
      id: null,
      contact: "",
      name: "",
      amway: null,
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      accountnum: "",
      giftcard: null,
      fax: "",
      email: "",
      excdynamicvendor: null,
      showsuppaddprdinfo: null,
      suppaddprdinfotitle: "",
      suppaddprdinfodesc: "",
    },
    addedSupplierId: null,
  }),

  getters: {
    allSuppliers: (state) => state.suppliers,
    suppliersResults: (state) => state.suppliersResults,
    supplierById: (state) => state.supplier,
  },

  actions: {
    fetchAllSuppliers({ commit }, data) {
      return new Promise((resolve, reject) => {
        getAllSuppliers(data)
          .then((resp) => {
            console.log(resp, "from getAllSuppliers");
            commit("SET_SUPPLIERS", resp);
            commit("SET_SUPPLIERS_RESULTS", resp);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err, "from getAllSuppliers");
          });
      });
    },

    fetchSupplierById({ commit }, params) {
      return new Promise((resolve, reject) => {
        getSupplierById(params)
          .then((resp) => {
            console.log(resp, "from getSupplierbyId");
            commit("SET_SUPPLIER_BY_ID", resp);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err, "from getSupplierbyId");
          });
      });
    },

    addSupplier({ state, commit }, form) {
      return new Promise((resolve, reject) => {
        insertSupplier(form)
          .then((id) => {
            state.addedSupplierId = id;
            resolve(id);
          })
          .catch(() => {
            console.log("error from add supplier action");
          });
      });
    },
    updateSupplier({ commit }, form) {
      return new Promise((resolve, reject) => {
        editSupplier(form)
          .then((resp) => {
            console.log(resp, "from update supplier action");
            resolve(resp);
          })
          .catch(() => {
            console.log("error from edit supplier action");
          });
      });
    },
    removeSupplier({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteSupplier(id)
          .then((resp) => {
            console.log(resp, "from delete supplier action");
            resolve(resp);
          })
          .catch(() => {
            console.log("error from delete supplier action");
          });
      });
    },
  },

  mutations: {
    SET_SUPPLIERS: (state, suppliers) => {
      state.suppliers = suppliers;
    },
    SET_SUPPLIERS_RESULTS: (state, suppliers) => {
      state.suppliersResults = suppliers.Result?.filter((supplier) => supplier.name.trim() != "")
    },
    SET_SUPPLIER_BY_ID: (state, supplier) => {
      state.supplier = supplier;
    },
  },
};

export default manageSuppliers;
